// routes.js

import Services from "../pages/services";
import ForgotPassword from "../pages/forgotpassword";
import HomePage from "../pages/home";
import LoginPage from "../pages/login";
import VendorLogin from "../pages/vendor-login";
import RegistrationPage from "../pages/registration";
import VendorRegistration from "../pages/vendor-registration";
import BlogPage from "../pages/blogs";
import BlogInner from "../pages/blog-inner";
import BookingPage from "../pages/booking";
import VenderResetPassword from "../pages/vendor-reset-pasword";
import EmailVerificationPage from "../pages/vendor-verification";
import ResetPassword from "../pages/resetpassword";
import VerificationPage from "../pages/verification";
import PrivateRoute from "./privateRoute";
import MyAccount from "../pages/my-account";
import ListService from "../components/my-account/list-service";
import MyServices from "../components/my-account/ongoing-services";
import MyQuotes from "../components/my-account/my-quotes";
import VenderForgotPassword from "../pages/vender-forgotpassword";
import PageNotFound from "../pages/page-not-found";
import ContactUs from "../pages/contact-us";
import CareerPage from "../pages/career";
import Questionnaire from "../pages/questionnaire";
import MyProfile from "../components/my-account/profile";
import ThankyouPage from "../pages/thankyou";
import ThankyouPageBooking from "../pages/thankyou-booking";
import VendorAccount from "../pages/vendor-account";
import VendorProfile from "../components/vendor-account/vendor-profile";
import MyDouments from "../components/vendor-account/vendor-doument";
import VendorQuotes from "../components/vendor-account/vendor-quotes";
import PublicRoute from "./publicRoute";
import CompleteBooking from "../components/my-account/complete-booking";
import VendorOngoing from "../components/vendor-account/vendor-ongoing";
import VendorCompleted from "../components/vendor-account/vendor-comnpleted";
import AboutUs from "../pages/about-us";
import TermsCondition from "../pages/terms-conditions";
import AntiDiscriminationPolicy from "../pages/anti-discrimination-policy";
import Faqs from "../pages/faqs";
import PrivacyPolicy from "../pages/privacy-policy";
import OwnerOtpVerification from "../pages/OwnerOtpVerification";
import VendorOtpVerification from "../pages/VendorOtpVerification";
import OwnerLoginOtpVerification from "../pages/OwnerLoginOtpVerification";
import VendorLoginOtpVerification from "../pages/VendorLoginOtpVerification";
const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/:details/:id",
    element: <Services />,
  },
  {
    path: "/register",
    element: <PublicRoute element={<RegistrationPage />} />,
  },
  {
    path: "/vendor-register",
    element: <PublicRoute element={<VendorRegistration />} />,
  },
  {
    path: "/login",
    element: <PublicRoute element={<LoginPage />} />,
  },
  {
    path: "/customer-otp-verification",
    element: <PublicRoute element={<OwnerOtpVerification />} />,
  },
  {
    path: "/vendor-otp-verification",
    element: <PublicRoute element={<VendorOtpVerification />} />,
  },
  {
    path: "/owner-login-otp-verification",
    element: <PublicRoute element={<OwnerLoginOtpVerification />} />,
  },
  {
    path: "/vendor-login-otp-verification",
    element: <PublicRoute element={<VendorLoginOtpVerification />} />,
  },
  {
    path: "/vendor-login",
    element: <PublicRoute element={<VendorLogin />} />,
  },
  {
    path: "/vendor-forgot-password",
    element: <PublicRoute element={<VenderForgotPassword />} />,
  },
  {
    path: "/vendor-verification/:vendorGuid",
    element: <EmailVerificationPage />,
  },
  {
    path: "/verification/:ownerGuid",
    element: <VerificationPage />,
  },
  {
    path: "/vender-reset-password",
    element: <VenderResetPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/blogs",
    element: <BlogPage />,
  },
  {
    path: "/blogs/:slug",
    element: <BlogInner />,
  },
  {
    path: "/book-service",
    element: <BookingPage />,
  },
  {
    path: "/book-service/:id",
    element: <PrivateRoute element={<BookingPage />} />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/careers",
    element: <CareerPage />,
  },
  {
    path: "/consult",
    element: <Questionnaire />,
  },

  {
    path: "/consult/:guideType",
    element: <Questionnaire />,
  },

  {
    path: "/thank-you",
    element: <PrivateRoute element={<ThankyouPage />} />,
  },
  {
    path: "/booking-success",
    element: <PrivateRoute element={<ThankyouPageBooking />} />,
  },
  {
    path: "/terms-condition",
    element: <TermsCondition />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/anti-discrimination-policy",
    element: <AntiDiscriminationPolicy />,
  },
  {
    path: "/faqs",
    element: <Faqs />,
  },

  {
    path: "/my-account",
    element: <PrivateRoute element={<MyAccount />} />,
    children: [
      { path: "profile", element: <PrivateRoute element={<MyProfile />} /> },
      {
        path: "list-service",
        element: <PrivateRoute element={<ListService />} />,
      },
      {
        path: "ongoing-booking",
        element: <PrivateRoute element={<MyServices />} />,
      },
      { path: "my-quotes", element: <PrivateRoute element={<MyQuotes />} /> },
      {
        path: "complete-booking",
        element: <PrivateRoute element={<CompleteBooking />} />,
      },
    ],
  },
  {
    path: "/vendor-account",
    element: <PrivateRoute element={<VendorAccount />} />,
    children: [
      {
        path: "vendor-profile",
        element: <PrivateRoute element={<VendorProfile />} />,
      },
      {
        path: "vendor-doument",
        element: <PrivateRoute element={<MyDouments />} />,
      },
      {
        path: "vendor-comnpleted",
        element: <PrivateRoute element={<VendorCompleted />} />,
      },
      {
        path: "vendor-ongoings",
        element: <PrivateRoute element={<VendorOngoing />} />,
      },
      {
        path: "my-quotes",
        element: <PrivateRoute element={<VendorQuotes />} />,
      },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];

export default routes;
